import { render, staticRenderFns } from "./SaveSearch.vue?vue&type=template&id=57019fe8&scoped=true"
import script from "./SaveSearch.vue?vue&type=script&lang=js"
export * from "./SaveSearch.vue?vue&type=script&lang=js"
import style0 from "./SaveSearch.vue?vue&type=style&index=0&id=57019fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57019fe8",
  null
  
)

export default component.exports